export default "//yastatic.net/s3/distribution/pythia/frontend/_/2710afe3aea3fc42a704700377097c59.png";